const Cookie = {
    get(key) {
        const matches = RegExp(`(^|;) ?${escapeRegExp(key)}=([^;$]*)`).exec(
            document.cookie
        );

        if (matches) {
            return matches[2];
        }

        return null;
    },

    set(key, value, params) {
        this._setCookie(`${key}=${value}${this._getCookieParamString(params)}`);
    },

    del(key, { path, domain } = {}) {
        this.set(key, "", { expiryTime: new Date(-1), path, domain });
    },

    // Adding for testing purpose
    _setCookie(value) {
        document.cookie = value;
    },

    _getCookieParamString({ expiryTime, path, domain, isSecure = true } = {}) {
        const cookieParam = [`; path=${path || "/"}`];

        if (expiryTime) {
            cookieParam.push(`expires=${expiryTime.toGMTString()}`);
        }

        if (domain) {
            cookieParam.push(`domain=${domain}`);
        }

        if (isSecure) {
            cookieParam.push("secure");
        }

        return cookieParam.join("; ");
    },
};

function escapeRegExp(str) {
    // eslint-disable-next-line no-useless-escape
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

export default Cookie;

export const { get, set, del, _setCookie, _getCookieParamString } = Cookie;
